import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import PageSectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-section-group-layout.vue";
import { defineComponent, toRefs, computed, ref, watch, nextTick } from "@vue/composition-api";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import RadioField from "@Shared/components/form-elements/fields/radio-field.vue";
import SelectField from "@Shared/components/form-elements/fields/select-field.vue";
import DateField from "@Shared/components/form-elements/fields/date-field.vue";
import CurrencyField from "@Shared/components/form-elements/fields/currency-field.vue";
import SinField from "@Shared/components/form-elements/fields/sin-field.vue";
import NumberField from "@Shared/components/form-elements/fields/number-field.vue";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import AddMoreButton from "@Client/@Modules/application-standalone/components/helpers/add-more-button.vue";
import DeleteElementIcon from "@Client/@Modules/application-standalone/components/helpers/delete-element-icon.vue";
import ApplicantAddress from "@Client/@Modules/application-standalone/components/pages/applicants/applicant-address.vue";
import { validationMixin } from "vuelidate";
import { applicantValidator } from "@Client/@Composables/application-standalone/validations/applicantValidator";
import NotificationPopover from "@Shared/components/general/notification-popover.vue";
import { applicantBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/applicants/applicantBindingsAndVisibilities";
import { get } from "lodash";
import { useI18n } from "vue-i18n-composable";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
export default defineComponent({
  name: "ApplicantsInformation",
  components: {
    PageSectionGroupLayout,
    SectionTitle,
    TextField,
    RadioField,
    SelectField,
    DateField,
    CurrencyField,
    AddMoreButton,
    DeleteElementIcon,
    ApplicantAddress,
    SinField,
    NumberField,
    NotificationPopover
  },
  mixins: [validationMixin],
  props: {
    applicantIndex: {
      type: Number,
      required: true
    },
    applicantId: {
      type: String,
      default: ""
    },
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    const {
      showErrors
    } = toRefs(props);
    const applicantAddressComponent = ref();
    const {
      t
    } = useI18n();
    const {
      IS_FILL_OUT
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.IS_FILL_OUT]);
    const {
      addLivingHistoryAddress,
      deleteLivingHistoryAddress,
      handleDecryptSin
    } = useApplicantHelpers();
    const {
      applicantIndex,
      applicantId
    } = toRefs(props);
    const isMainApplicantInfo = computed(() => applicantIndex.value === 0);
    const handleAddAnotherAddress = () => {
      addLivingHistoryAddress(applicantIndex.value);
    };
    const handleDeleteAddress = addressIndex => {
      deleteLivingHistoryAddress(applicantIndex.value, addressIndex);
    };
    const {
      yesNoOptions,
      maritalStatusOptions,
      applicantLivingSituationOptions,
      salutationOptions,
      languagePreferenceOptions,
      coApplicantTypeOptions,
      relationshipToMainApplicantOptions
    } = APPLICATION_FIELD_OPTIONS();
    const {
      bindings,
      visibilities
    } = applicantBindingsAndVisibilities(applicantIndex, applicantId);
    const {
      salutation,
      firstName,
      middleName,
      lastName,
      email,
      phoneNumber,
      altPhoneNumber,
      workPhone,
      firstTimeHomeBuyer,
      maritalStatus,
      sin,
      dateOfBirth,
      numChildren,
      languagePreference,
      own,
      monthlyRent,
      coApplicantType,
      relationshipToMainApplicant,
      addresses
    } = bindings;
    const decryptingSin = ref(false);
    const handleShowSin = () => {
      handleDecryptSin(props.applicantIndex, decryptingSin);
    };
    const {
      applicantSalutationVisible,
      applicantFirstNameVisible,
      applicantMiddleNameVisible,
      applicantLastNameVisible,
      applicantEmailVisible,
      applicantPhoneNumberVisible,
      applicantWorkPhoneVisible,
      applicantAltPhoneNumberVisible,
      applicantFirstTimeHomeBuyerVisible,
      applicantMaritalStatusVisible,
      applicantDateOfBirthVisible,
      applicantNumChildrenVisible,
      applicantLanguagePreferenceVisible,
      applicantOwnVisible,
      applicantMonthlyRentVisible,
      coApplicantTypeVisible,
      applicantRelationshipToMainApplicantVisible,
      applicantAddressesVisible,
      applicantSinVisible
    } = visibilities;
    const {
      v$
    } = applicantValidator(applicantIndex);
    const isValid = computed(() => {
      var _v$$value$$invalid, _v$$value;
      return (_v$$value$$invalid = !(v$ != null && (_v$$value = v$.value) != null && _v$$value.$invalid)) != null ? _v$$value$$invalid : false;
    });
    const showTimeAcrossResidencesWarning = computed(() => {
      var _context;
      const totalTime = _reduceInstanceProperty(_context = addresses.value).call(_context, (time, address) => {
        var _address$timeAt;
        time = time + ((_address$timeAt = address == null ? void 0 : address["time-at"]) != null ? _address$timeAt : 0);
        return time;
      }, 0);
      return totalTime < 36;
    });
    const getAddAddressText = computed(() => {
      return addresses.value.length ? t("application-standalone.pages.applicants.addAnotherAddress") : t("application-standalone.pages.applicants.addYourCurrentAddress");
    });
    const isLivingHistoryRequired = computed(() => {
      return getValidator("address.required") || getValidator("own.required") || getValidator("monthlyRent.required");
    });
    watch(isValid, newVal => {
      emit("disable-save", !newVal);
    }, {
      immediate: true
    });
    watch(showErrors, newVal => {
      if (newVal) {
        var _v$$value2;
        v$ == null ? void 0 : (_v$$value2 = v$.value) == null ? void 0 : _v$$value2.$touch();
        if (!addresses.value.length) handleAddAnotherAddress();
        nextTick(() => {
          var _applicantAddressComp;
          (_applicantAddressComp = applicantAddressComponent.value) == null ? void 0 : _applicantAddressComp.forEach(addressComponent => addressComponent.showErrors());
        });
      }
    });
    const getValidator = path => get(v$.value, path, null);
    const hasMultipleAddresses = computed(() => {
      return addresses.value.length > 1;
    });
    return {
      salutation,
      firstName,
      middleName,
      lastName,
      email,
      phoneNumber,
      altPhoneNumber,
      workPhone,
      firstTimeHomeBuyer,
      maritalStatus,
      sin,
      dateOfBirth,
      numChildren,
      languagePreference,
      own,
      monthlyRent,
      coApplicantType,
      relationshipToMainApplicant,
      addresses,
      yesNoOptions,
      maritalStatusOptions,
      applicantLivingSituationOptions,
      salutationOptions,
      isMainApplicantInfo,
      languagePreferenceOptions,
      coApplicantTypeOptions,
      relationshipToMainApplicantOptions,
      handleAddAnotherAddress,
      handleDeleteAddress,
      handleShowSin,
      decryptingSin,
      applicantSalutationVisible,
      applicantFirstNameVisible,
      applicantMiddleNameVisible,
      applicantLastNameVisible,
      applicantEmailVisible,
      applicantPhoneNumberVisible,
      applicantWorkPhoneVisible,
      applicantAltPhoneNumberVisible,
      applicantFirstTimeHomeBuyerVisible,
      applicantMaritalStatusVisible,
      applicantDateOfBirthVisible,
      applicantNumChildrenVisible,
      applicantLanguagePreferenceVisible,
      applicantOwnVisible,
      applicantMonthlyRentVisible,
      coApplicantTypeVisible,
      applicantRelationshipToMainApplicantVisible,
      applicantAddressesVisible,
      applicantSinVisible,
      showTimeAcrossResidencesWarning,
      v$,
      getValidator,
      getAddAddressText,
      isLivingHistoryRequired,
      applicantAddressComponent,
      IS_FILL_OUT,
      hasMultipleAddresses
    };
  }
});